module.exports = __webpack_public_path__ + "static/img/all_game.ae7fe952.png";